import { CdkDragDrop, CdkDragEnd } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
declare let $: any;

@Component({
  selector: 'app-malad',
  templateUrl: './malad.component.html',
  styleUrls: ['./malad.component.scss']
})
export class MaladComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    
    
  }

  drop(event: CdkDragEnd): void{
    console.log(event);
  }

  numb: any=[
    {
      n:'1',
      xy:'181px 0 0 63px'
    },
    {
      n:'2',
      xy:'181px 0 0 91px'
    },
    {
      n:'3',
      xy:'181px 0 0 122px'
    },
    {
      n:'4',
      xy:'181px 0 0 182px'
    },
    {
      n:'5',
      xy:'181px 0 0 210px'
    },
    {
      n:'6',
      xy:'181px 0 0 241px'
    },
    {
      n:'7',
      xy:'225px 0 0 63px'
    },
    {
      n:'8',
      xy:'225px 0 0 91px'
    },
    {
      n:'9',
      xy:'225px 0 0 122px'
    },
    {
      n:'10',
      xy:'225px 0 0 182px'
    },
    {
      n:'11',
      xy:'225px 0 0 210px'
    },
    {
      n:'12',
      xy:'225px 0 0 241px'
    },
    {
      n:'13',
      xy:'273px 0 0 63px'
    },
    {
      n:'14',
      xy:'273px 0 0 91px'
    },
    {
      n:'15',
      xy:'273px 0 0 122px'
    },
    {
      n:'16',
      xy:'273px 0 0 182px'
    },
    {
      n:'17',
      xy:'273px 0 0 210px'
    },
    {
      n:'18',
      xy:'273px 0 0 241px'
    },
    {
      n:'19',
      xy:'174px 0 0 329px'
    },
    {
      n:'20',
      xy:'174px 0 0 392px'
    },
    {
      n:'21',
      xy:'199px 0 0 329px'
    },
    {
      n:'22',
      xy:'199px 0 0 392px'
    },
    {
      n:'23',
      xy:'224px 0 0 329px'
    },
    {
      n:'24',
      xy:'224px 0 0 392px'
    },
    {
      n:'25',
      xy:'280px 0 0 522px'
    },
    {
      n:'26',
      xy:'178px 0 0 663px'
    },
    {
      n:'27',
      xy:'202px 0 0 663px'
    },
    {
      n:'28',
      xy:'187px 0 0 764px'
    },
    {
      n:'29',
      xy:'187px 0 0 801px'
    },
    {
      n:'30',
      xy:'219px 0 0 764px'
    },
    {
      n:'31',
      xy:'219px 0 0 801px'
    },
    {
      n:'32',
      xy:'288px 0 0 764px'
    },
    {
      n:'33',
      xy:'288px 0 0 801px'
    },
    {
      n:'34',
      xy:'320px 0 0 764px'
    },
    {
      n:'35',
      xy:'320px 0 0 801px'
    },
    {
      n:'36',
      xy:'312px 0 0 652px'
    },
    {
      n:'37',
      xy:'312px 0 0 690px'
    },
    {
      n:'38',
      xy:'344px 0 0 652px'
    },
    {
      n:'39',
      xy:'344px 0 0 690px'
    },
    {
      n:'40',
      xy:'370px 0 0 83px'
    },
    {
      n:'41',
      xy:'412px 0 0 62px'
    },
    {
      n:'42',
      xy:'412px 0 0 90px'
    },
    {
      n:'43',
      xy:'362px 0 0 184px'
    },
    {
      n:'44',
      xy:'402px 0 0 161px'
    },
    {
      n:'45',
      xy:'402px 0 0 188px'
    },
    {
      n:'46',
      xy:'362px 0 0 295px'
    },
    {
      n:'47',
      xy:'402px 0 0 290px'
    },
    {
      n:'48',
      xy:'402px 0 0 318px'
    },
    {
      n:'49',
      xy:'479px 0 0 65px'
    },
    {
      n:'50',
      xy:'479px 0 0 110px' 
    },
    {
      n:'51',
      xy:'475px 0 0 208px'
    },
    {
      n:'52',
      xy:'475px 0 0 253px' 
    },
    {
      n:'53',
      xy:'475px 0 0 298px'
    },
    {
      n:'54',
      xy:'533px 0 0 208px'
    },
    {
      n:'55',
      xy:'533px 0 0 253px'
    },
    {
      n:'56',
      xy:'533px 0 0 298px'
    },
    {
      n:'57',
      xy:'558px 0 0 208px'
    },
    {
      n:'58',
      xy:'558px 0 0 253px'
    },
    {
      n:'59',
      xy:'558px 0 0 298px'
    },
    {
      n:'60',
      xy:'618px 0 0 208px'
    },
    {
      n:'61',
      xy:'618px 0 0 253px'
    },
    {
      n:'62',
      xy:'618px 0 0 298px'
    },
    {
      n:'63',
      xy:'642px 0 0 208px'
    },
    {
      n:'64',
      xy:'642px 0 0 253px'
    },
    {
      n:'65',
      xy:'642px 0 0 298px'
    },
    {
      n:'66',
      xy:'703px 0 0 208px'
    },
    {
      n:'67',
      xy:'703px 0 0 253px'
    },
    {
      n:'68',
      xy:'703px 0 0 298px'
    },
    {
      n:'69',
      xy:'728px 0 0 208px'
    },
    {
      n:'70',
      xy:'728px 0 0 253px'
    },
    {
      n:'71',
      xy:'728px 0 0 298px'
    },
    {
      n:'72',
      xy:'788px 0 0 208px'
    },
    {
      n:'73',
      xy:'788px 0 0 253px'
    },
    {
      n:'74',
      xy:'788px 0 0 298px'
    },
    {
      n:'75',
      xy:'813px 0 0 208px'
    },
    {
      n:'76',
      xy:'813px 0 0 253px'
    },
    {
      n:'77',
      xy:'813px 0 0 298px'
    },
    {
      n:'78',
      xy:'747px 0 0 136px'
    },
    {
      n:'79',
      xy:'793px 0 0 136px'
    },
    {
      n:'80',
      xy:'872px 0 0 208px'
    },
    {
      n:'81',
      xy:'872px 0 0 253px'
    },
    {
      n:'82',
      xy:'872px 0 0 298px'
    },
    {
      n:'83',
      xy:'901px 0 0 208px'
    },
    {
      n:'84',
      xy:'901px 0 0 253px'
    },
    {
      n:'85',
      xy:'901px 0 0 298px'
    },
    {
      n:'86',
      xy:'959px 0 0 208px'
    },
    {
      n:'87',
      xy:'959px 0 0 253px'
    },
    {
      n:'88',
      xy:'959px 0 0 298px'
    },
    {
      n:'89',
      xy:'900px 0 0 132px'
    },
    {
      n:'90',
      xy:'861px 0 0 118px'
    },
    {
      n:'91',
      xy:'861px 0 0 146px'
    },
    {
      n:'92',
      xy:'539px 0 0 73px'
    },
    {
      n:'93',
      xy:'548px 0 0 119px'
    },
    {
      n:'94',
      xy:'523px 0 0 119px'
    },
    {
      n:'95',
      xy:'618px 0 0 83px'
    },
    {
      n:'96',
      xy:'658px 0 0 60px'
    },
    {
      n:'97',
      xy:'658px 0 0 88px'
    },
    {
      n:'98',
      xy:'347px 0 0 438px'
    },
    {
      n:'99',
      xy:'347px 0 0 478px'
    },
    {
      n:'100',
      xy:'347px 0 0 547px'
    },
    {
      n:'101',
      xy:'347px 0 0 590px'
    },
    {
      n:'102',
      xy:'381px 0 0 438px'
    },
    {
      n:'103',
      xy:'381px 0 0 478px'
    },
    {
      n:'104',
      xy:'381px 0 0 547px'
    },
    {
      n:'105',
      xy:'381px 0 0 590px'
    },
    {
      n:'106',
      xy:'417px 0 0 438px'
    },
    {
      n:'107',
      xy:'417px 0 0 478px'
    },
    {
      n:'108',
      xy:'417px 0 0 547px'
    },
    {
      n:'109',
      xy:'417px 0 0 590px'
    },
    {
      n:'110',
      xy:'452px 0 0 438px'
    },
    {
      n:'111',
      xy:'452px 0 0 478px'
    },
    {
      n:'112',
      xy:'452px 0 0 547px'
    },
    {
      n:'113',
      xy:'452px 0 0 590px'
    },
    {
      n:'114',
      xy:'490px 0 0 438px'
    },
    {
      n:'115',
      xy:'490px 0 0 478px'
    },
    {
      n:'116',
      xy:'490px 0 0 547px'
    },
    {
      n:'117',
      xy:'490px 0 0 590px'
    },
    {
      n:'118',
      xy:'550px 0 0 438px'
    },
    {
      n:'119',
      xy:'550px 0 0 478px'
    },
    {
      n:'120',
      xy:'550px 0 0 547px' 
    },
    {
      n:'121',
      xy:'550px 0 0 590px'  
     },
    {
      n:'122',
      xy:'586px 0 0 438px'  
     },
    {
      n:'123',
      xy:'586px 0 0 478px' 
      },
    {
      n:'124',
      xy:'586px 0 0 547px'
    },
    {
      n:'125',
      xy:'586px 0 0 590px'
    },
    {
      n:'126',
      xy:'621px 0 0 438px'
    },
    {
      n:'127',
      xy:'621px 0 0 478px'
    },
    {
      n:'128',
      xy:'621px 0 0 547px'
    },
    {
      n:'129',
      xy:'621px 0 0 590px'
    },
    {
      n:'130',
      xy:'658px 0 0 438px'
    },
    {
      n:'131',
      xy:'658px 0 0 478px'
    },
    {
      n:'132',
      xy:'658px 0 0 547px'
    },
    {
      n:'133',
      xy:'658px 0 0 590px'
    },
    {
      n:'134',
      xy:'693px 0 0 438px'
    },
    {
      n:'135',
      xy:'693px 0 0 478px'
    },
    {
      n:'136',
      xy:'693px 0 0 547px'
    },
    {
      n:'137',
      xy:'693px 0 0 590px'
    },
    {
      n:'138',
      xy:'437px 0 0 664px'
    },
    {
      n:'139',
      xy:'437px 0 0 725px'
    },
    {
      n:'140',
      xy:'470px 0 0 664px'
    },
    {
      n:'141',
      xy:'470px 0 0 725px'
    },
    {
      n:'142',
      xy:'558px 0 0 690px'
    },
    {
      n:'143',
      xy:'636px 0 0 648px'
    },
    {
      n:'144',
      xy:'636px 0 0 703px'
    },
    {
      n:'145',
      xy:'660px 0 0 648px'
    },
    {
      n:'146',
      xy:'660px 0 0 703px'
    },
    {
      n:'147',
      xy:'685px 0 0 648px'
    },
    {
      n:'148',
      xy:'685px 0 0 703px'
    },
    {
      n:'149',
      xy:'646px 0 0 745px'
    },
    {
      n:'150',
      xy:'646px 0 0 773px'
    },
    {
      n:'151',
      xy:'686px 0 0 759px'
    },
    {
      n:'152',
      xy:'719px 0 0 438px'
    },
    {
      n:'153',
      xy:'719px 0 0 478px'
    },
    {
      n:'154',
      xy:'719px 0 0 547px'
    },
    {
      n:'155',
      xy:'719px 0 0 590px'
    },
    {
      n:'156',
      xy:'753px 0 0 438px'
    },
    {
      n:'157',
      xy:'753px 0 0 478px'
    },
    {
      n:'158',
      xy:'753px 0 0 547px'
    },
    {
      n:'159',
      xy:'753px 0 0 590px'
    },
    {
      n:'160',
      xy:'789px 0 0 438px'
    },
    {
      n:'161',
      xy:'789px 0 0 478px'
    },
    {
      n:'162',
      xy:'789px 0 0 547px'
    },
    {
      n:'163',
      xy:'789px 0 0 590px'
    },
    {
      n:'164',
      xy:'789px 0 0 438px'
    },
    {
      n:'165',
      xy:'789px 0 0 478px'
    },
    {
      n:'166',
      xy:'789px 0 0 547px'
    },
    {
      n:'167',
      xy:'789px 0 0 590px'
    },
    {
      n:'168',
      xy:'867px 0 0 438px'
    },
    {
      n:'169',
      xy:'867px 0 0 478px'
    },
    {
      n:'170',
      xy:'867px 0 0 547px'
    },
    {
      n:'171',
      xy:'867px 0 0 590px'
    },
    {
      n:'172',
      xy:'900px 0 0 438px'
    },
    {
      n:'173',
      xy:'900px 0 0 478px'
    },
    {
      n:'174',
      xy:'900px 0 0 547px'
    },
    {
      n:'175',
      xy:'900px 0 0 590px'
    },
    {
      n:'176',
      xy:'937px 0 0 438px'
    },
    {
      n:'177',
      xy:'937px 0 0 478px'
    },
    {
      n:'178',
      xy:'937px 0 0 547px'
    },
    {
      n:'180',
      xy:'937px 0 0 590px'
    },
    {
      n:'181',
      xy:'718px 0 0 661px'
    },
    {
      n:'182',
      xy:'732px 0 0 686px'
    },
    {
      n:'183',
      xy:'768px 0 0 686px'
    },
    {
      n:'184',
      xy:'751px 0 0 661px'
    },
    {
      n:'185',
      xy:'790px 0 0 661px'
    },
    {
      n:'185',
      xy:'728px 0 0 789px'
    },
    {
      n:'186',
      xy:'769px 0 0 811px'
    },
    {
      n:'187',
      xy:'769px 0 0 787px'
    },
    {
      n:'188',
      xy:'769px 0 0 760px'
    },
    {
      n:'189',
      xy:'887px 0 0 811px'
    },
    {
      n:'190',
      xy:'887px 0 0 787px'
    },
    {
      n:'191',
      xy:'887px 0 0 760px'
    },
    {
      n:'192',
      xy:'928px 0 0 789px'
    },
    {
      n:'193',
      xy:'900px 0 0 667px'
    },
    {
      n:'194',
      xy:'900px 0 0 707px'
    },
    {
      n:'195',
      xy:'930px 0 0 667px'
    },
    {
      n:'196',
      xy:'930px 0 0 707px'
    },
    {
      n:'197',
      xy:'1019px 0 0 118px'
    },
    {
      n:'198',
      xy:'1019px 0 0 166px'
    },
    {
      n:'199',
      xy:'1019px 0 0 211px'
    },
    {
      n:'190',
      xy:'1045px 0 0 118px'
    },
    {
      n:'191',
      xy:'1045px 0 0 166px'
    },
    {
      n:'192',
      xy:'1045px 0 0 211px'
    },
    {
      n:'193',
      xy:'1103px 0 0 80px'
    },
    {
      n:'194',
      xy:'1103px 0 0 126px'
    },
    {
      n:'195',
      xy:'1103px 0 0 172px'
    },
    {
      n:'196',
      xy:'1103px 0 0 211px'
    },
    {
      n:'197',
      xy:'1136px 0 0 80px'
    },
    {
      n:'198',
      xy:'1136px 0 0 218px'
    },
    {
      n:'199',
      xy:'1195px 0 0 80px'
    },
    {
      n:'200',
      xy:'1195px 0 0 126px'
    },
    {
      n:'201',
      xy:'1195px 0 0 172px'
    },
    {
      n:'202',
      xy:'1195px 0 0 218px'
    },
    {
      n:'203',
      xy:'1236px 0 0 80px'
    },
    {
      n:'204',
      xy:'1236px 0 0 126px'
    },
    {
      n:'205',
      xy:'1236px 0 0 172px'
    },
    {
      n:'206',
      xy:'1236px 0 0 218px'
    },
    {
      n:'207',
      xy:'1119px 0 0 349px'
    },
    {
      n:'208',
      xy:'1119px 0 0 404px'
    },
    {
      n:'209',
      xy:'1119px 0 0 515px'
    },
    {
      n:'210',
      xy:'1119px 0 0 584px'
    },
    {
      n:'211',
      xy:'1154px 0 0 349px'
    },
    {
      n:'212',
      xy:'1154px 0 0 404px'
    },
    {
      n:'213',
      xy:'1154px 0 0 471px'
    },
    {
      n:'214',
      xy:'1154px 0 0 515px'
    },
    {
      n:'215',
      xy:'1154px 0 0 584px'
    },
    {
      n:'216',
      xy:'1189px 0 0 349px'
    },
    {
      n:'217',
      xy:'1189px 0 0 404px'
    },
    {
      n:'218',
      xy:'1189px 0 0 471px'
    },
    {
      n:'219',
      xy:'1189px 0 0 515px'
    },
    {
      n:'220',
      xy:'1094px 0 0 679px'
    },
    {
      n:'221',
      xy:'1094px 0 0 707px'
    },
    {
      n:'222',
      xy:'1132px 0 0 685px'
    },
    {
      n:'223',
      xy:'1193px 0 0 589px'
    },
    {
      n:'224',
      xy:'1193px 0 0 630px'
    },
    {
      n:'225',
      xy:'1193px 0 0 699px'
    },
    {
      n:'226',
      xy:'1228px 0 0 348px'
    },
    {
      n:'227',
      xy:'1228px 0 0 402px'
    },
    {
      n:'228',
      xy:'1228px 0 0 471px'
    },
    {
      n:'229',
      xy:'1228px 0 0 519px'
    },
    {
      n:'230',
      xy:'1228px 0 0 588px'
    },
    {
      n:'231',
      xy:'1228px 0 0 630px'
    },
    {
      n:'232',
      xy:'1228px 0 0 700px'
    },
    {
      n:'233',
      xy:'1265px 0 0 348px'
    },
    {
      n:'234',
      xy:'1265px 0 0 402px'
    },
    {
      n:'235',
      xy:'1265px 0 0 471px'
    },
    {
      n:'236',
      xy:'1265px 0 0 519px'
    },
    {
      n:'237',
      xy:'1265px 0 0 588px'
    },
    {
      n:'238',
      xy:'1265px 0 0 630px'
    },
    {
      n:'239',
      xy:'1265px 0 0 700px'
    },
    {
      n:'240',
      xy:'1300px 0 0 348px'
    },
    {
      n:'241',
      xy:'1300px 0 0 402px'
    },
    {
      n:'242',
      xy:'1300px 0 0 471px'
    },
    {
      n:'243',
      xy:'1300px 0 0 519px'
    },
    {
      n:'244',
      xy:'1300px 0 0 588px'
    },
    {
      n:'245',
      xy:'1300px 0 0 630px'
    },
    {
      n:'245',
      xy:'1300px 0 0 700px'
    },
    {
      n:'246',
      xy:'1380px 0 0 348px'
    },
    {
      n:'247',
      xy:'1380px 0 0 402px'
    },
    {
      n:'248',
      xy:'1380px 0 0 471px'
    },
    {
      n:'249',
      xy:'1380px 0 0 512px'
    },
    {
      n:'250',
      xy:'1380px 0 0 581px'
    },
    {
      n:'251',
      xy:'1380px 0 0 624px'
    },
    {
      n:'252',
      xy:'1417px 0 0 348px'
    },
    {
      n:'253',
      xy:'1417px 0 0 402px'
    },
    {
      n:'254',
      xy:'1417px 0 0 471px'
    },
    {
      n:'255',
      xy:'1417px 0 0 512px'
    },
    {
      n:'256',
      xy:'1417px 0 0 581px'
    },
    {
      n:'257',
      xy:'1417px 0 0 624px'
    },
    {
      n:'258',
      xy:'1450px 0 0 348px'
    },
    {
      n:'259',
      xy:'1450px 0 0 402px'
    },
    {
      n:'260',
      xy:'1172px 0 0 752px'
    },
    {
      n:'261',
      xy:'1197px 0 0 752px'
    },
    {
      n:'262',
      xy:'1220px 0 0 752px'
    },
    {
      n:'263',
      xy:'1190px 0 0 796px'
    },
    {
      n:'264',
      xy:'1339px 0 0 782px'
    },
    {
      n:'265',
      xy:'1428px 0 0 746px'
    },
    {
      n:'266',
      xy:'1428px 0 0 785px'
    },
    {
      n:'267',
      xy:'1461px 0 0 746px'
    },
    {
      n:'268',
      xy:'1461px 0 0 785px'
    },
    {
      n:'269',
      xy:'1491px 0 0 141px'
    },
    {
      n:'270',
      xy:'1510px 0 0 108px'
    },
    {
      n:'271',
      xy:'1510px 0 0 175px'
    },
    {
      n:'272',
      xy:'1536px 0 0 103px'
    },
    {
      n:'273',
      xy:'1536px 0 0 179px'
    },
    {
      n:'274',
      xy:'1536px 0 0 103px'
    },
    {
      n:'275',
      xy:'1536px 0 0 179px'
    },
    {
      n:'276',
      xy:'1560px 0 0 104px'
    },
    {
      n:'277',
      xy:'1560px 0 0 179px'
    },
    {
      n:'278',
      xy:'1584px 0 0 106px'
    },
    {
      n:'279',
      xy:'1584px 0 0 176px'
    },
    {
      n:'280',
      xy:'1608px 0 0 116px'
    },
    {
      n:'281',
      xy:'1608px 0 0 170px'
    },
    {
      n:'282',
      xy:'1661px 0 0 79px'
    },
    {
      n:'283',
      xy:'1661px 0 0 118px'
    },
    {
      n:'284',
      xy:'1697px 0 0 79px'
    },
    {
      n:'285',
      xy:'1697px 0 0 118px'
    },
    {
      n:'286',
      xy:'1738px 0 0 75px'
    },
    {
      n:'287',
      xy:'1738px 0 0 120px'
    },
    {
      n:'288',
      xy:'1738px 0 0 167px'
    },
    {
      n:'289',
      xy:'1738px 0 0 212px'
    },
    {
      n:'290',
      xy:'1797px 0 0 75px'
    },
    {
      n:'291',
      xy:'1797px 0 0 120px'
    },
    {
      n:'292',
      xy:'1797px 0 0 167px'
    },
    {
      n:'293',
      xy:'1797px 0 0 212px'
    },
    {
      n:'294',
      xy:'1820px 0 0 120px'
    },
    {
      n:'295',
      xy:'1820px 0 0 167px'
    },
    {
      n:'296',
      xy:'1820px 0 0 212px'
    },
    {
      n:'297',
      xy:'1753px 0 0 275px'
    },
    {
      n:'298',
      xy:'1788px 0 0 275px'
    }
    
    
  ];




}
